export default "__VITE_ASSET__1757dc0f__"